import * as React from 'react';
import { Helmet } from 'react-helmet';
import { checkMetaTag, metaTagValue, prop } from '../../utilities';
import { connect } from 'react-redux';

interface Props {
  tags: any;
  metaTags: null;
}

class MetaTags extends React.PureComponent<Props, {}> {
  public render() {
    const { tags, metaTags } = this.props;

    function renderDescr() {
      if (tags?.description) {
        return (
          <meta name="description" content={checkMetaTag(tags.description)} />
        );
      }
      if (metaTags && prop(metaTags, 'description')) {
        return (
          <meta
            name="description"
            content={checkMetaTag(prop(metaTags, 'description'))}
          />
        );
      }
      return null;
    }

    function renderKeyWords() {
      if (tags?.keywords) {
        return <meta name="keywords" content={checkMetaTag(tags.keywords)} />;
      }
      if (metaTags && prop(metaTags, 'keywords')) {
        return (
          <meta
            name="keywords"
            content={checkMetaTag(prop(metaTags, 'keywords'))}
          />
        );
      }
      return null;
    }

    const ogTitle = metaTagValue(tags?.og_title) || metaTagValue(tags?.title);
    const ogType = metaTagValue(tags?.og_type);
    const ogDescription =
      metaTagValue(tags?.og_description) ||
      metaTagValue(tags?.description) ||
      metaTagValue(prop(metaTags, 'description'));
    const ogUrl = metaTagValue(tags?.og_url);
    const ogImage = metaTagValue(tags?.og_image);
    const ogArticleAuthor = metaTagValue(tags?.og_article_author);
    const ogArticleSection = metaTagValue(tags?.og_article_section);
    const ogArticleTag = metaTagValue(tags?.og_article_tag);

    return (
      <React.Fragment>
        {tags !== {} && (
          <Helmet>
            {tags?.title && <title>{checkMetaTag(tags.title)}</title>}

            {renderDescr()}

            {renderKeyWords()}

            {ogTitle && <meta property="og:title" content={ogTitle} />}
            <meta property="og:type" content={ogType || 'website'} />

            {ogDescription && (
              <meta property="og:description" content={ogDescription} />
            )}
            {ogUrl && <meta property="og:url" content={ogUrl} />}
            {ogImage && <meta property="og:image" content={ogImage} />}
            {ogImage && tags?.og_image_width && (
              <meta property="og:image:width" content={tags.og_image_width} />
            )}
            {ogImage && tags?.og_image_height && (
              <meta property="og:image:height" content={tags.og_image_height} />
            )}
            {ogArticleAuthor && (
              <meta name="article:author" content={ogArticleAuthor} />
            )}
            {ogArticleSection && (
              <meta name="article:section" content={ogArticleSection} />
            )}
            {ogArticleTag && <meta name="article:tag" content={ogArticleTag} />}
            {tags?.robots && (
              <meta name="robots" content={checkMetaTag(tags.robots)} />
            )}

            <meta
              name="google-site-verification"
              content="mNYq_qNR8B69ajC4WRIABkYbHnP3V-pUUAhcZt5jEns"
            />
          </Helmet>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    metaTags: state.general.metaTags,
  };
};
export default connect(mapStateToProps)(MetaTags);
